import { CallActionPayload, ContextValue, MethodResponse } from '../../types';
import { ContextAPI } from '../ImpactAiContextProvider';

export const setContext = (payload: CallActionPayload, contextApi: ContextAPI): MethodResponse => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    throw new Error('payload must be an object for set-context method');
  }

  Object.entries(payload).forEach(([key, value]) => {
    contextApi.setValue(key, value as ContextValue);
  });

  return {};
};
